import { request } from '@/api/http';
import type { OrgUsageSummary } from '@/api/services/billingAdmin';
import type { UsageSummary } from '@/api/types';

export const usageService = {
  /** Organization usage for the current member (organization inferred from session). */
  summary: (period = 'current_month', organizationId?: string) => {
    const params = new URLSearchParams({ period });
    if (organizationId) params.set('organization_id', organizationId);
    return request<OrgUsageSummary>(`/usage/summary?${params}`);
  },

  /** Platform-wide usage for operator dashboards. */
  platformSummary: (period = 'current_month') =>
    request<UsageSummary>(`/usage/platform-summary?period=${encodeURIComponent(period)}`),
};

export type { OrgUsageSummary };
